import React from 'react';

interface TooltipProps {
  text: string;
}

export const Tooltip: React.FC<TooltipProps> = ({ text }) => {
  return (
    <div className="relative inline-flex items-center ml-2 group cursor-help" tabIndex={0} aria-label="Help">
      <div className="w-4 h-4 rounded-full border border-cv-border-strong text-cv-muted flex items-center justify-center text-[9px] font-bold group-hover:text-cv-primary group-hover:border-cv-border-strong group-hover:bg-cv-elevated group-focus:text-cv-primary transition-colors">
        ?
      </div>
      
      <div className="absolute z-[100] bottom-full left-1/2 -translate-x-1/2 mb-2 w-48 p-2 bg-cv-panel border border-cv-border-strong rounded-lg shadow-xl text-[10px] text-cv-secondary font-normal leading-tight text-center opacity-0 invisible group-hover:opacity-100 group-hover:visible group-focus:opacity-100 group-focus:visible transition-all duration-200 pointer-events-none">
        {text}
        <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-cv-border-strong"></div>
        <div className="absolute top-full left-1/2 -translate-x-1/2 border-[3px] border-transparent border-t-cv-panel -mt-[1px]"></div>
      </div>
    </div>
  );
};

export default Tooltip;
